import messages from '@src/common/messages.json';
import { event as eapmEvent } from '@uhg-abyss/web/tools/event';

export const getLandingStatusError = (res) => {
  const statusCode = res.status;
  const { data, duration, endpoint, message } = res;
  const errorData = {
    status: data?.error?.code,
    message: data?.error?.description || message,
    code: statusCode,
    duration,
    endpoint,
  };
  eapmEvent('EAPM_TRANSACTION_ERROR', errorData);

  if (res.status === 401) {
    throw {
      statusCode,
      message: messages.ACCESS_CODE_NOT_FOUND,
    };
  }

  return res;
};
